module.exports = __webpack_public_path__ + "img/篮球.5f8c4e40.gif";